import { Pipe, PipeTransform } from '@angular/core';

import { pedidoStatusAmostra } from '../pedido-status-amostra';

@Pipe({
    name: 'pedidoStatusAmostra'
})
export class PedidoStatusAmostraPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = pedidoStatusAmostra.findIndex(statusAmostra => statusAmostra.id === value);
        if (index > -1) {
            return pedidoStatusAmostra[index].nome;
        }
        return '';
    }
}
